import { render, staticRenderFns } from "./PaletteGrid.vue?vue&type=template&id=61b9064c&"
import script from "./PaletteGrid.vue?vue&type=script&lang=js&"
export * from "./PaletteGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports